import { isDemo } from "../App";
import { axiosRequest } from "../axiosConfig";
import preCachedData from "./data.json";

class FaxCacheManager {
  constructor() {
    this.cache = new Map();
    this.maxCacheSize = 50;
    this.storageKey = "processedFaxData";
  }

  async readFromCache(faxId) {
    try {
      // Check pre-cached data first
      if (preCachedData && preCachedData[faxId]?.processed_fax_data) {
        console.log("Found fax data in pre-cached JSON:", faxId);
        return preCachedData[faxId].processed_fax_data;
      }

      // Check in-memory cache
      const cacheKey = `${faxId}_fax`;
      if (this.cache.has(cacheKey)) {
        console.log("Found fax data in memory cache");
        return this.cache.get(cacheKey).processed_fax_data;
      }

      return null;
    } catch (error) {
      console.error("Error reading from fax cache:", error);
      return null;
    }
  }

  async writeToCache(faxId, data) {
    try {
      const cacheKey = `${faxId}_fax`;
      const cacheEntry = {
        processed_fax_data: data,
        timestamp: new Date().toISOString(),
      };

      // Update in-memory cache
      this.cache.set(cacheKey, cacheEntry);

      // Maintain cache size limit
      if (this.cache.size > this.maxCacheSize) {
        const oldestKey = this.cache.keys().next().value;
        this.cache.delete(oldestKey);
      }

      // Update persistent storage
      if (typeof sessionStorage !== "undefined") {
        try {
          const persistentCache = {};
          this.cache.forEach((value, key) => {
            persistentCache[key] = value;
          });
          sessionStorage.setItem(
            this.storageKey,
            JSON.stringify(persistentCache),
          );
        } catch (err) {
          console.log("Error writing to persistent cache:", err);
        }
      }
    } catch (error) {
      console.error("Error writing to cache:", error);
    }
  }

  async fetchProcessedFax(url, faxId) {
    try {
      // Try to get from cache first
      const cachedData = await this.readFromCache(faxId);
      if (isDemo && cachedData) {
        return cachedData;
      }

      // If not in cache, fetch from API
      console.log("Fetching processed fax data from API");
      const response = await axiosRequest.get(url);

      // Check for error response
      if (typeof response.data === "string" && response.data.length > 2) {
        throw new Error(response.data);
      }

      // Cache the response
      await this.writeToCache(faxId, response.data);

      return response.data;
    } catch (error) {
      console.error("Error fetching processed fax:", error);
      window.location.reload();
      if (error?.response?.data?.length < 2) {
        throw new Error(error?.response?.data[0]?.Message);
      } else {
        throw new Error(error?.response?.data || error.message);
      }
    }
  }
}

// Export singleton instance
export const faxCacheManager = new FaxCacheManager();
